import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
// import Button from "@mui/material/Button";
import DateRange from "../../../common/dateTime/DateRange";
import closeIcon from "../../../assets/close.png";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 550,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const CustomerCareFilters = (props) => {
  const {
    open,
    handleFilterModalClose,
    filterSearchedData,
    selectedFilterRange,
    clearAllFilters,
  } = props;
  const [appliedFilters, setAppliedFilters] = useState({
    email: "",
    phone: null,
    ticketId: "",
    status: "",
    name: "",
    clinicId: "",
    doctorId: "",
    date: null,
  });
  const [filterRange, setFilterRange] = useState({
    startDate: "",
    endDate: "",
    color: "",
  });
  const [openRange, setOpenRange] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(false);
  const [isDatePicked, setIsDatePicked] = useState(false);
  const daterange = {
    inputlabel: "Filter by date",
    btnlable: "Apply",
    btnlableClear: "Clear",
    customStyle: {
      txtStyle: {
        textAlign: "center",
      },
      frmStyle: {
        position: "absolute",
        zIndex: 1,
        top: "15%",
        left: "30%",
      },
    },
    pckrStyle: true,
    handleFilter: (val) => {
      setFilterDateRange(val);
    },
    openRange: openRange,
    setOpenRange: setOpenRange,
    setFilterRange: setFilterRange,
    filterRange: !isDatePicked && filterRange,
  };

  useEffect(() => {
    if (!isFilterCleared) {
      setFilterRange(() => selectedFilterRange);
    }
  }, []);

  const setFilterDateRange = (val) => {
    setFilterRange(() => val);
    setOpenRange(() => false);
  };

  const setFilters = (name, e) => {
    const { value } = e?.target;
    const filter = { ...appliedFilters };
    filter[name] = value;
    setAppliedFilters(() => filter);
  };

  const clearFilters = () => {
    setIsFilterCleared(() => true);
    const filter = {
      email: "",
      phone: null,
      ticketId: "",
      status: "",
      name: "",
      clinicId: "",
      doctorId: "",
      date: null,
    };
    clearAllFilters();
    setAppliedFilters(() => filter);
  };

  const applyFilters = () => {
    filterSearchedData(appliedFilters, filterRange, 1);
    setIsFilterCleared(() => false);
  };

  const handleSelect = () => {
    const temp = {
      startDate: "",
      endDate: "",
      color: "",
    };
    setFilterRange(() => temp);
    setIsDatePicked(() => true);
  };

  return (
    <Modal
      open={open}
      onClose={() => handleFilterModalClose(appliedFilters, filterRange)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div
          style={{
            background: "rgb(240, 241, 245)",
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            height: "10%",
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <p>
            <b>Filters & Search</b>
          </p>
          <img
            style={{
              height: "20px",
              position: "absolute",
              right: "30px",
              cursor: "pointer",
            }}
            src={closeIcon}
            onClick={() => handleFilterModalClose()}
          />
        </div>
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          style={{ marginTop: "20px" }}
        >
          <Grid
            item
            xs={12}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ display: "inline-flex", justifyContent: "space-between" }}
          >
            <TextField
              id="outlined-basic"
              label="Search By Email"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("email", e)}
              size="small"
              value={appliedFilters.email}
            />
            <TextField
              id="outlined-basic"
              label="Search By Phone Number"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("phone", e)}
              size="small"
              value={appliedFilters.phone}
            />
          </Grid>
          <Grid
            item
            xs={12}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ display: "inline-flex", justifyContent: "space-between" }}
          >
            <TextField
              id="outlined-basic"
              label="Search By Ticket ID"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("ticketId", e)}
              value={appliedFilters.ticketId}
              size="small"
            />
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={appliedFilters.status}
              // label="Age"
              onChange={(e) => setFilters("status", e)}
              style={{ width: "40%", marginRight: "10px" }}
              size="small"
            >
              <MenuItem value={"Open"}>Open</MenuItem>
              <MenuItem value={"Pending"}>Pending</MenuItem>
              <MenuItem value={"Resolved"}>Resolved</MenuItem>
              <MenuItem value={"Tech Team"}>Tech Team</MenuItem>
              <MenuItem value={"Cancelled"}>Cancelled </MenuItem>
            </Select>
            {/* <TextField
              id="outlined-basic"
              label="Filter By Status"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("status", e)}
              value={appliedFilters.status}
              size="small"
            /> */}
          </Grid>
          <Grid
            item
            xs={12}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ display: "inline-flex", justifyContent: "space-between" }}
          >
            <TextField
              id="outlined-basic"
              label="Search By Name"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("name", e)}
              value={appliedFilters.name}
              size="small"
            />
            <TextField
              id="outlined-basic"
              label="Search By Clinic ID"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("clinicId", e)}
              value={appliedFilters.clinicId}
              size="small"
            />
          </Grid>
          <Grid
            item
            xs={12}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ display: "inline-flex", justifyContent: "space-between" }}
          >
            <TextField
              id="outlined-basic"
              label="Search By Doctor ID"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("doctorId", e)}
              value={appliedFilters.doctorId}
              size="small"
            />
            <div style={{ marginRight: "10px", width: "42%" }}>
              <Button
                variant="outlined"
                style={{
                  border: "1px solid #f0f1f5",
                  background: "#f0f1f5",
                  color: "#afafaf",
                  padding: "8px",
                  width: "100%",
                }}
                size="large"
                onClick={() => setOpenRange(() => !openRange)}
              >
                {filterRange.startDate.length && filterRange.endDate.length
                  ? `${filterRange.startDate} - ${filterRange.endDate}`
                  : "Filter BY Date"}
              </Button>
              <DateRange {...daterange} onChange={() => handleSelect()} />
            </div>
            {/* <TextField
              id="outlined-basic"
              label="Filter By Date"
              variant="outlined"
              style={{ margin: "10px" }}
              onChange={(e) => setFilters("date", e)}
              value={appliedFilters.date}
            /> */}
          </Grid>
          <Grid
            style={{
              width: "100%",
              display: "inline-flex",
              justifyContent: "end",
              marginTop: "25px",
              marginRight: "10px",
            }}
          >
            <Button
              variant="outlined"
              //   size="small"
              onClick={() => clearFilters()}
              style={{ minWidth: "10rem", borderRadius: "15px" }}
              sx={1}
            >
              Clear
            </Button>
            <Button
              variant="contained"
              //   size="small"
              onClick={() => applyFilters()}
              style={{
                marginLeft: "30px",
                minWidth: "10rem",
                borderRadius: "15px",
                color: "white",
              }}
            >
              Apply
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default CustomerCareFilters;
